import { Injectable, inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';

@Injectable()
export class PageLoaderService {
  private spinner = inject(NgxSpinnerService);


  openCount = 0;
  spinner$ = this.spinner.spinnerObservable;

  open$ = new Subject();
  close$ = new Subject();

  open() {
    if (this.openCount == 0) {
      this.spinner.show();
      this.open$.next(true);
    }
    this.openCount++;
  }

  close() {

    this.openCount--;
    if (this.openCount < 0) this.openCount = 0;
    if (this.openCount == 0) {
      this.spinner.hide();
      this.close$.next(true);
    }
  }
}
